// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bootstrap 5 and AdminLTE Compatibility Fixes */

/* Force hide ALL sidebar elements when collapsed */
body.sidebar-collapse aside,
body.sidebar-collapse .main-sidebar,
body.sidebar-collapse .sidebar,
body.sidebar-collapse .left-side,
body.sidebar-collapse .sidebar-wrapper,
body.sidebar-collapse .sidebar-mini-hide {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    width: 0 !important;
    overflow: hidden !important;
}

/* Reset AdminLTE body classes for public pages */
body:not(.hold-transition):not(.skin-blue):not(.sidebar-mini) {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
    background: #fff !important;
    margin: 0 !important;
    padding: 0 !important;
}

/* AdminLTE Layout Fixes */
body.hold-transition.skin-blue.sidebar-mini {
    font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
    overflow-x: hidden !important;
}

/* Wrapper Layout */
.wrapper {
    position: relative !important;
    min-height: 100vh !important;
    overflow: hidden !important;
}

/* Fixed Header */
.main-header {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    left: 0 !important; /* Changed from 230px to 0 */
    z-index: 1030 !important;
    height: 50px !important;
    transition: left 0.3s ease-in-out !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    display: flex !important;
    align-items: center !important;
}

/* Logo and Brand Styling - Keep your brand colors */
.main-header .logo {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: #fff !important;
    border-bottom: 0 solid transparent !important;
    border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
    height: 50px !important;
    line-height: 50px !important;
    text-align: center !important;
    width: 230px !important;
    position: static !important; /* Changed from fixed to static */
    top: auto !important;
    left: auto !important;
    z-index: auto !important;
    font-weight: bold !important;
    flex-shrink: 0 !important;
    display: flex !important;
    align-items: center !important;
}

/* Sidebar collapsed state */
body.sidebar-collapse .main-header {
    left: 0 !important;
}

body.sidebar-collapse .main-header .logo {
    display: none !important; /* Completely hide the logo */
    width: 0 !important;
    visibility: hidden !important;
    opacity: 0 !important;
}

body.sidebar-collapse .main-header .logo .logo-lg {
    display: none !important;
}

.main-header .logo:hover {
    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%) !important;
}

/* Navbar styling - Professional layout */
.main-header .navbar {
    background: transparent !important;
    margin: 0 !important;
    border: none !important;
    min-height: 50px !important;
    border-radius: 0 !important;
    padding: 0 !important;
    flex: 1 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
}

/* Fix hamburger button positioning */
.main-header .sidebar-toggle {
    color: #fff !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    cursor: pointer !important;
    margin: 0 10px !important;
    font-size: 16px !important;
    height: 50px !important;
    width: 50px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    order: 1 !important; /* First item in navbar */
    flex-shrink: 0 !important;
    text-decoration: none !important;
}

/* Add hamburger icon */
.main-header .sidebar-toggle::before {
    content: '\\2630' !important; /* Unicode hamburger menu */
    font-size: 18px !important;
    line-height: 1 !important;
}

.main-header .sidebar-toggle:hover,
.main-header .sidebar-toggle:focus {
    background: rgba(255, 255, 255, 0.1) !important;
    color: #fff !important;
    text-decoration: none !important;
    outline: none !important;
}

/* Navbar content layout */
.main-header .navbar-nav {
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    height: 50px !important;
}

.main-header .navbar-custom-menu {
    position: relative !important;
    order: 2 !important; /* Second item in navbar */
    margin-left: auto !important;
}

/* User menu styling - preserve your design */
.main-header .navbar-nav > .user-menu > .dropdown-toggle {
    color: #fff !important;
    padding: 12px 15px !important;
    height: 50px !important;
    display: flex !important;
    align-items: center !important;
}

.main-header .navbar-nav > .user-menu > .dropdown-toggle:hover {
    background: rgba(255, 255, 255, 0.1) !important;
    text-decoration: none !important;
}

/* Fix navbar brand text positioning */
.main-header .navbar-brand {
    color: #fff !important;
    font-size: 18px !important;
    font-weight: bold !important;
    padding: 12px 15px !important;
    height: 50px !important;
    line-height: 26px !important;
}

/* Professional breadcrumb styling */
.content-wrapper .content-header {
    padding: 15px !important;
    background: #fff !important;
    border-bottom: 1px solid #f0f0f0 !important;
    margin-bottom: 0 !important;
}

/* Fixed Sidebar */
.main-sidebar {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 230px !important;
    height: 100vh !important;
    z-index: 1025 !important; /* Higher z-index for mobile clicking */
    background: #222d32 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0.3s ease-in-out !important;
    transform: translateX(0) !important;
}

/* Ensure sidebar wrapper doesn't show */
body.sidebar-collapse .sidebar-mini-hide {
    display: none !important;
}

body.sidebar-collapse .left-side,
body.sidebar-collapse .main-sidebar-wrapper {
    display: none !important;
}

/* Content Wrapper - Fixed positioning */
.content-wrapper {
    position: relative !important;
    margin-left: 230px !important;
    margin-top: 50px !important;
    min-height: calc(100vh - 50px) !important;
    background: #ecf0f5 !important;
    padding: 15px !important;
    transition: margin-left 0.3s ease-in-out !important;
    z-index: 820 !important;
    width: calc(100% - 230px) !important;
    box-sizing: border-box !important;
}

/* Footer positioning */
.main-footer {
    position: relative !important;
    margin-left: 230px !important;
    transition: margin-left 0.3s ease-in-out !important;
    width: calc(100% - 230px) !important;
    box-sizing: border-box !important;
}

/* Sidebar Collapse State - Completely hide sidebar */
body.sidebar-collapse .main-sidebar {
    transform: translateX(-100%) !important; /* Use percentage for complete hide */
    visibility: hidden !important; /* Also make it invisible */
    opacity: 0 !important; /* And transparent */
    display: none !important; /* Force hide completely */
}

/* Hide any potential sidebar remnants */
body.sidebar-collapse .sidebar-wrapper,
body.sidebar-collapse .sidebar,
body.sidebar-collapse .left-side {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
}

body.sidebar-collapse .content-wrapper,
body.sidebar-collapse .main-footer {
    margin-left: 0 !important; /* No margin when collapsed */
    width: 100% !important; /* Full width when collapsed */
}

/* Keep header full width when sidebar is collapsed */
body.sidebar-collapse .main-header {
    left: 0 !important;
}

body.sidebar-collapse .main-header .logo {
    width: 50px !important;
}

body.sidebar-collapse .main-header .logo .logo-lg {
    display: none !important;
}

/* Mobile sidebar behavior */
@media (max-width: 767px) {
    /* Ensure content is visible on mobile regardless of sidebar state */
    .content-wrapper,
    .main-footer {
        margin-left: 0 !important;
        padding-left: 15px !important;
        padding-right: 15px !important;
        width: 100% !important;
        box-sizing: border-box !important;
    }
    
    .main-header {
        left: 0 !important;
        width: 100% !important;
    }
    
    /* Keep logo visible on mobile but make it smaller */
    .main-header .logo {
        width: 180px !important; /* Smaller on mobile */
    }
    
    .main-sidebar {
        transform: translateX(-230px) !important;
        transition: transform 0.3s ease-in-out !important;
        z-index: 1030 !important; /* Higher z-index for mobile */
    }
    
    body.sidebar-open .main-sidebar {
        transform: translateX(0) !important;
    }
    
    /* Mobile overlay when sidebar is open - lower z-index than sidebar */
    body.sidebar-open::before {
        content: '';
        position: fixed;
        top: 0;
        left: 230px; /* Start after sidebar */
        width: calc(100% - 230px);
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1025;
        display: block;
        pointer-events: auto;
    }
    
    /* Ensure sidebar content is clickable */
    body.sidebar-open .main-sidebar * {
        pointer-events: auto !important;
        z-index: inherit !important;
    }
    
    /* Force content wrapper to be visible and properly positioned */
    body.sidebar-collapse .content-wrapper,
    body.sidebar-collapse .main-footer {
        margin-left: 0 !important;
        width: 100% !important;
        padding-left: 15px !important;
        padding-right: 15px !important;
    }
    
    /* On mobile, when collapsed, make logo even smaller */
    body.sidebar-collapse .main-header .logo {
        width: 50px !important;
        display: flex !important; /* Keep it visible but small */
        visibility: visible !important;
        opacity: 1 !important;
    }
    
    body.sidebar-collapse .main-header .logo .logo-lg {
        display: none !important;
    }
}

/* Sidebar Toggle Button Fix */
.sidebar-toggle {
    color: #fff !important;
    background: transparent !important;
    border: none !important;
    padding: 15px !important;
    cursor: pointer !important;
}

.sidebar-toggle:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}

/* Sidebar Menu Styling */
.sidebar-menu {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
}

.sidebar-menu > li > a {
    position: relative !important;
    display: block !important;
    padding: 12px 15px !important;
    color: #b8c7ce !important;
    text-decoration: none !important;
}

.sidebar-menu > li > a:hover,
.sidebar-menu > li.active > a {
    background: #1e282c !important;
    color: #fff !important;
}

/* Sidebar Dropdown Menu */
.sidebar-menu .treeview-menu {
    display: none !important;
    list-style: none !important;
    padding: 0 !important;
    margin: 0 !important;
    background: #2c3b41 !important;
}

.sidebar-menu .treeview.active .treeview-menu {
    display: block !important;
}

.sidebar-menu .treeview-menu > li > a {
    padding: 8px 15px 8px 30px !important;
    font-size: 16px !important;
    color: #8aa4af !important;
}

.sidebar-menu .treeview-menu > li > a:hover {
    color: #fff !important;
}

/* Fix Bootstrap 5 conflicts */
.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
    --bs-gutter-x: 1.5rem !important;
    --bs-gutter-y: 0 !important;
}

/* Ensure Bootstrap 5 utilities work properly */
.d-none { display: none !important; }
.d-block { display: block !important; }
.d-flex { display: flex !important; }
.justify-content-center { justify-content: center !important; }
.align-items-center { align-items: center !important; }
.text-center { text-align: center !important; }
.w-100 { width: 100% !important; }
.h-100 { height: 100% !important; }

/* Bootstrap 5 spacing utilities */
.m-0 { margin: 0 !important; }
.p-0 { padding: 0 !important; }
.mt-3 { margin-top: 1rem !important; }
.mb-3 { margin-bottom: 1rem !important; }
.py-3 { padding-top: 1rem !important; padding-bottom: 1rem !important; }
.px-3 { padding-left: 1rem !important; padding-right: 1rem !important; }
.py-5 { padding-top: 3rem !important; padding-bottom: 3rem !important; }

/* Fix potential z-index issues */
.navbar { z-index: 1030 !important; }
.dropdown-menu { z-index: 1000 !important; }
.modal { z-index: 1055 !important; }
.modal-backdrop { z-index: 1050 !important; }

/* Fix font awesome conflicts */
.fa, .fas, .far, .fal, .fab {
    font-family: "Font Awesome 6 Free", "Font Awesome 6 Brands", "FontAwesome" !important;
}

/* Public Page Container - Override AdminLTE for public pages */
.public-page-container {
    background: #f0f2f5 !important;
    min-height: 100vh !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    position: relative !important;
    z-index: auto !important;
}

/* Ensure public pages don't inherit admin panel styles */
body:not(.hold-transition) .public-page-container,
body:not(.skin-blue) .public-page-container,
body:not(.sidebar-mini) .public-page-container {
    margin-left: 0 !important;
    padding-left: 0 !important;
}

/* Global Font Size Improvements - Make text larger and more readable */
body, html {
    font-size: 16px !important;
    line-height: 1.6 !important;
}

/* Fix font sizes for lists across the entire project */
ul, ol, li {
    font-size: 16px !important;
    line-height: 1.6 !important;
}

/* Specific fixes for different contexts */
.content-wrapper ul,
.content-wrapper ol,
.content-wrapper li,
.main-content ul,
.main-content ol,
.main-content li {
    font-size: 16px !important;
    line-height: 1.6 !important;
}

/* Sidebar menu items should be readable */
.sidebar-menu ul,
.sidebar-menu ol,
.sidebar-menu li,
.main-sidebar ul,
.main-sidebar ol,
.main-sidebar li {
    font-size: 16px !important;
    line-height: 1.5 !important;
}

/* Navigation and dropdown menus */
.navbar-nav ul,
.navbar-nav ol,
.navbar-nav li,
.dropdown-menu ul,
.dropdown-menu ol,
.dropdown-menu li {
    font-size: 16px !important;
    line-height: 1.5 !important;
}

/* Public pages should have normal font sizes */
.public-page-container ul,
.public-page-container ol,
.public-page-container li {
    font-size: 18px !important;
    line-height: 1.6 !important;
}

/* General text elements */
p, div, span, a, button, input, textarea, select {
    font-size: 16px !important;
}

/* Table text */
table, td, th {
    font-size: 16px !important;
}

/* Form elements */
.form-control, .form-select, .btn {
    font-size: 16px !important;
}

/* Card and content areas */
.card, .card-body, .box, .box-body {
    font-size: 16px !important;
}

/* Override small text classes */
.small, small {
    font-size: 14px !important;
}

/* ---------- Map fullscreen mode ---------- */
/* Header and sidebar are position:fixed, so they must be targeted directly rather than
   via opacity/transform on a wrapper div, which fixed descendants ignore. */
.admin-chrome-hidden .main-header {
    transform: translateY(-100%) !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
    transition: transform 0.3s ease, opacity 0.3s ease, visibility 0s linear 0.3s !important;
}

.admin-chrome-hidden .main-sidebar {
    transform: translateX(-100%) !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
    transition: transform 0.3s ease, opacity 0.3s ease, visibility 0s linear 0.3s !important;
}

.content-wrapper.content-wrapper-fullscreen {
    margin-left: 0 !important;
    margin-top: 0 !important;
    width: 100% !important;
    min-height: 100vh !important;
    padding: 0 !important;
    transition: margin-left 0.35s ease-in-out, margin-top 0.35s ease-in-out, width 0.35s ease-in-out !important;
}
`, "",{"version":3,"sources":["webpack://./src/BootstrapAdminLTEFix.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD,mDAAmD;AACnD;;;;;;IAMI,wBAAwB;IACxB,6BAA6B;IAC7B,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,iDAAiD;AACjD;IACI,yFAAyF;IACzF,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;IACI,4GAA4G;IAC5G,6BAA6B;AACjC;;AAEA,mBAAmB;AACnB;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB,EAAE,4BAA4B;IAChD,wBAAwB;IACxB,uBAAuB;IACvB,4CAA4C;IAC5C,wEAAwE;IACxE,4DAA4D;IAC5D,gDAAgD;IAChD,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA,oDAAoD;AACpD;IACI,wEAAwE;IACxE,sBAAsB;IACtB,6CAA6C;IAC7C,2DAA2D;IAC3D,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B,EAAE,iCAAiC;IAC9D,oBAAoB;IACpB,qBAAqB;IACrB,wBAAwB;IACxB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB,EAAE,6BAA6B;IACvD,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wEAAwE;AAC5E;;AAEA,yCAAyC;AACzC;IACI,kCAAkC;IAClC,oBAAoB;IACpB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA,qCAAqC;AACrC;IACI,sBAAsB;IACtB,kCAAkC;IAClC,uBAAuB;IACvB,qBAAqB;IACrB,0BAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB,EAAE,yBAAyB;IAC9C,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,uBAAuB;AACvB;IACI,2BAA2B,EAAE,2BAA2B;IACxD,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;;IAEI,+CAA+C;IAC/C,sBAAsB;IACtB,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA,0BAA0B;AAC1B;IACI,oBAAoB;IACpB,wBAAwB;IACxB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB,EAAE,0BAA0B;IAC/C,4BAA4B;AAChC;;AAEA,6CAA6C;AAC7C;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,+CAA+C;IAC/C,gCAAgC;AACpC;;AAEA,sCAAsC;AACtC;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA,oCAAoC;AACpC;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB,EAAE,uCAAuC;IACjE,8BAA8B;IAC9B,2BAA2B;IAC3B,6BAA6B;IAC7B,wGAAwG;IACxG,mCAAmC;AACvC;;AAEA,wCAAwC;AACxC;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA,wCAAwC;AACxC;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;IAC3B,yCAAyC;IACzC,8BAA8B;IAC9B,wBAAwB;IACxB,mDAAmD;IACnD,uBAAuB;IACvB,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA,uBAAuB;AACvB;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,mDAAmD;IACnD,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA,qDAAqD;AACrD;IACI,uCAAuC,EAAE,qCAAqC;IAC9E,6BAA6B,EAAE,2BAA2B;IAC1D,qBAAqB,EAAE,oBAAoB;IAC3C,wBAAwB,EAAE,0BAA0B;AACxD;;AAEA,wCAAwC;AACxC;;;IAGI,wBAAwB;IACxB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB,EAAE,6BAA6B;IACxD,sBAAsB,EAAE,8BAA8B;AAC1D;;AAEA,qDAAqD;AACrD;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,4BAA4B;AAC5B;IACI,oEAAoE;IACpE;;QAEI,yBAAyB;QACzB,6BAA6B;QAC7B,8BAA8B;QAC9B,sBAAsB;QACtB,iCAAiC;IACrC;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA,oDAAoD;IACpD;QACI,uBAAuB,EAAE,sBAAsB;IACnD;;IAEA;QACI,wCAAwC;QACxC,iDAAiD;QACjD,wBAAwB,EAAE,8BAA8B;IAC5D;;IAEA;QACI,mCAAmC;IACvC;;IAEA,qEAAqE;IACrE;QACI,WAAW;QACX,eAAe;QACf,MAAM;QACN,WAAW,EAAE,wBAAwB;QACrC,yBAAyB;QACzB,YAAY;QACZ,8BAA8B;QAC9B,aAAa;QACb,cAAc;QACd,oBAAoB;IACxB;;IAEA,wCAAwC;IACxC;QACI,+BAA+B;QAC/B,2BAA2B;IAC/B;;IAEA,gEAAgE;IAChE;;QAEI,yBAAyB;QACzB,sBAAsB;QACtB,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA,sDAAsD;IACtD;QACI,sBAAsB;QACtB,wBAAwB,EAAE,8BAA8B;QACxD,8BAA8B;QAC9B,qBAAqB;IACzB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA,8BAA8B;AAC9B;IACI,sBAAsB;IACtB,kCAAkC;IAClC,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;AACnD;;AAEA,yBAAyB;AACzB;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;IAEI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,8BAA8B;AAC9B;;;;;;;IAOI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA,+CAA+C;AAC/C,UAAU,wBAAwB,EAAE;AACpC,WAAW,yBAAyB,EAAE;AACtC,UAAU,wBAAwB,EAAE;AACpC,0BAA0B,kCAAkC,EAAE;AAC9D,sBAAsB,8BAA8B,EAAE;AACtD,eAAe,6BAA6B,EAAE;AAC9C,SAAS,sBAAsB,EAAE;AACjC,SAAS,uBAAuB,EAAE;;AAElC,kCAAkC;AAClC,OAAO,oBAAoB,EAAE;AAC7B,OAAO,qBAAqB,EAAE;AAC9B,QAAQ,2BAA2B,EAAE;AACrC,QAAQ,8BAA8B,EAAE;AACxC,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;;AAEvE,iCAAiC;AACjC,UAAU,wBAAwB,EAAE;AACpC,iBAAiB,wBAAwB,EAAE;AAC3C,SAAS,wBAAwB,EAAE;AACnC,kBAAkB,wBAAwB,EAAE;;AAE5C,+BAA+B;AAC/B;IACI,qFAAqF;AACzF;;AAEA,+DAA+D;AAC/D;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA,yDAAyD;AACzD;;;IAGI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,uEAAuE;AACvE;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,uDAAuD;AACvD;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,0CAA0C;AAC1C;;;;;;IAMI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,0CAA0C;AAC1C;;;;;;IAMI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,kCAAkC;AAClC;;;;;;IAMI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,+CAA+C;AAC/C;;;IAGI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;AAC9B;;AAEA,2BAA2B;AAC3B;IACI,0BAA0B;AAC9B;;AAEA,gCAAgC;AAChC;IACI,0BAA0B;AAC9B;;AAEA,8CAA8C;AAC9C;4EAC4E;AAC5E;IACI,uCAAuC;IACvC,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;IAC/B,wFAAwF;AAC5F;;AAEA;IACI,uCAAuC;IACvC,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;IAC/B,wFAAwF;AAC5F;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;IAC5B,qBAAqB;IACrB,2GAA2G;AAC/G","sourcesContent":["/* Bootstrap 5 and AdminLTE Compatibility Fixes */\n\n/* Force hide ALL sidebar elements when collapsed */\nbody.sidebar-collapse aside,\nbody.sidebar-collapse .main-sidebar,\nbody.sidebar-collapse .sidebar,\nbody.sidebar-collapse .left-side,\nbody.sidebar-collapse .sidebar-wrapper,\nbody.sidebar-collapse .sidebar-mini-hide {\n    display: none !important;\n    visibility: hidden !important;\n    opacity: 0 !important;\n    width: 0 !important;\n    overflow: hidden !important;\n}\n\n/* Reset AdminLTE body classes for public pages */\nbody:not(.hold-transition):not(.skin-blue):not(.sidebar-mini) {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;\n    background: #fff !important;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n/* AdminLTE Layout Fixes */\nbody.hold-transition.skin-blue.sidebar-mini {\n    font-family: \"Source Sans Pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif !important;\n    overflow-x: hidden !important;\n}\n\n/* Wrapper Layout */\n.wrapper {\n    position: relative !important;\n    min-height: 100vh !important;\n    overflow: hidden !important;\n}\n\n/* Fixed Header */\n.main-header {\n    position: fixed !important;\n    top: 0 !important;\n    right: 0 !important;\n    left: 0 !important; /* Changed from 230px to 0 */\n    z-index: 1030 !important;\n    height: 50px !important;\n    transition: left 0.3s ease-in-out !important;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;\n    display: flex !important;\n    align-items: center !important;\n}\n\n/* Logo and Brand Styling - Keep your brand colors */\n.main-header .logo {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    color: #fff !important;\n    border-bottom: 0 solid transparent !important;\n    border-right: 1px solid rgba(255, 255, 255, 0.1) !important;\n    height: 50px !important;\n    line-height: 50px !important;\n    text-align: center !important;\n    width: 230px !important;\n    position: static !important; /* Changed from fixed to static */\n    top: auto !important;\n    left: auto !important;\n    z-index: auto !important;\n    font-weight: bold !important;\n    flex-shrink: 0 !important;\n    display: flex !important;\n    align-items: center !important;\n}\n\n/* Sidebar collapsed state */\nbody.sidebar-collapse .main-header {\n    left: 0 !important;\n}\n\nbody.sidebar-collapse .main-header .logo {\n    display: none !important; /* Completely hide the logo */\n    width: 0 !important;\n    visibility: hidden !important;\n    opacity: 0 !important;\n}\n\nbody.sidebar-collapse .main-header .logo .logo-lg {\n    display: none !important;\n}\n\n.main-header .logo:hover {\n    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%) !important;\n}\n\n/* Navbar styling - Professional layout */\n.main-header .navbar {\n    background: transparent !important;\n    margin: 0 !important;\n    border: none !important;\n    min-height: 50px !important;\n    border-radius: 0 !important;\n    padding: 0 !important;\n    flex: 1 !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n}\n\n/* Fix hamburger button positioning */\n.main-header .sidebar-toggle {\n    color: #fff !important;\n    background: transparent !important;\n    border: none !important;\n    padding: 0 !important;\n    cursor: pointer !important;\n    margin: 0 10px !important;\n    font-size: 16px !important;\n    height: 50px !important;\n    width: 50px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    order: 1 !important; /* First item in navbar */\n    flex-shrink: 0 !important;\n    text-decoration: none !important;\n}\n\n/* Add hamburger icon */\n.main-header .sidebar-toggle::before {\n    content: '\\2630' !important; /* Unicode hamburger menu */\n    font-size: 18px !important;\n    line-height: 1 !important;\n}\n\n.main-header .sidebar-toggle:hover,\n.main-header .sidebar-toggle:focus {\n    background: rgba(255, 255, 255, 0.1) !important;\n    color: #fff !important;\n    text-decoration: none !important;\n    outline: none !important;\n}\n\n/* Navbar content layout */\n.main-header .navbar-nav {\n    margin: 0 !important;\n    display: flex !important;\n    align-items: center !important;\n    height: 50px !important;\n}\n\n.main-header .navbar-custom-menu {\n    position: relative !important;\n    order: 2 !important; /* Second item in navbar */\n    margin-left: auto !important;\n}\n\n/* User menu styling - preserve your design */\n.main-header .navbar-nav > .user-menu > .dropdown-toggle {\n    color: #fff !important;\n    padding: 12px 15px !important;\n    height: 50px !important;\n    display: flex !important;\n    align-items: center !important;\n}\n\n.main-header .navbar-nav > .user-menu > .dropdown-toggle:hover {\n    background: rgba(255, 255, 255, 0.1) !important;\n    text-decoration: none !important;\n}\n\n/* Fix navbar brand text positioning */\n.main-header .navbar-brand {\n    color: #fff !important;\n    font-size: 18px !important;\n    font-weight: bold !important;\n    padding: 12px 15px !important;\n    height: 50px !important;\n    line-height: 26px !important;\n}\n\n/* Professional breadcrumb styling */\n.content-wrapper .content-header {\n    padding: 15px !important;\n    background: #fff !important;\n    border-bottom: 1px solid #f0f0f0 !important;\n    margin-bottom: 0 !important;\n}\n\n/* Fixed Sidebar */\n.main-sidebar {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: 230px !important;\n    height: 100vh !important;\n    z-index: 1025 !important; /* Higher z-index for mobile clicking */\n    background: #222d32 !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0.3s ease-in-out !important;\n    transform: translateX(0) !important;\n}\n\n/* Ensure sidebar wrapper doesn't show */\nbody.sidebar-collapse .sidebar-mini-hide {\n    display: none !important;\n}\n\nbody.sidebar-collapse .left-side,\nbody.sidebar-collapse .main-sidebar-wrapper {\n    display: none !important;\n}\n\n/* Content Wrapper - Fixed positioning */\n.content-wrapper {\n    position: relative !important;\n    margin-left: 230px !important;\n    margin-top: 50px !important;\n    min-height: calc(100vh - 50px) !important;\n    background: #ecf0f5 !important;\n    padding: 15px !important;\n    transition: margin-left 0.3s ease-in-out !important;\n    z-index: 820 !important;\n    width: calc(100% - 230px) !important;\n    box-sizing: border-box !important;\n}\n\n/* Footer positioning */\n.main-footer {\n    position: relative !important;\n    margin-left: 230px !important;\n    transition: margin-left 0.3s ease-in-out !important;\n    width: calc(100% - 230px) !important;\n    box-sizing: border-box !important;\n}\n\n/* Sidebar Collapse State - Completely hide sidebar */\nbody.sidebar-collapse .main-sidebar {\n    transform: translateX(-100%) !important; /* Use percentage for complete hide */\n    visibility: hidden !important; /* Also make it invisible */\n    opacity: 0 !important; /* And transparent */\n    display: none !important; /* Force hide completely */\n}\n\n/* Hide any potential sidebar remnants */\nbody.sidebar-collapse .sidebar-wrapper,\nbody.sidebar-collapse .sidebar,\nbody.sidebar-collapse .left-side {\n    display: none !important;\n    visibility: hidden !important;\n    opacity: 0 !important;\n}\n\nbody.sidebar-collapse .content-wrapper,\nbody.sidebar-collapse .main-footer {\n    margin-left: 0 !important; /* No margin when collapsed */\n    width: 100% !important; /* Full width when collapsed */\n}\n\n/* Keep header full width when sidebar is collapsed */\nbody.sidebar-collapse .main-header {\n    left: 0 !important;\n}\n\nbody.sidebar-collapse .main-header .logo {\n    width: 50px !important;\n}\n\nbody.sidebar-collapse .main-header .logo .logo-lg {\n    display: none !important;\n}\n\n/* Mobile sidebar behavior */\n@media (max-width: 767px) {\n    /* Ensure content is visible on mobile regardless of sidebar state */\n    .content-wrapper,\n    .main-footer {\n        margin-left: 0 !important;\n        padding-left: 15px !important;\n        padding-right: 15px !important;\n        width: 100% !important;\n        box-sizing: border-box !important;\n    }\n    \n    .main-header {\n        left: 0 !important;\n        width: 100% !important;\n    }\n    \n    /* Keep logo visible on mobile but make it smaller */\n    .main-header .logo {\n        width: 180px !important; /* Smaller on mobile */\n    }\n    \n    .main-sidebar {\n        transform: translateX(-230px) !important;\n        transition: transform 0.3s ease-in-out !important;\n        z-index: 1030 !important; /* Higher z-index for mobile */\n    }\n    \n    body.sidebar-open .main-sidebar {\n        transform: translateX(0) !important;\n    }\n    \n    /* Mobile overlay when sidebar is open - lower z-index than sidebar */\n    body.sidebar-open::before {\n        content: '';\n        position: fixed;\n        top: 0;\n        left: 230px; /* Start after sidebar */\n        width: calc(100% - 230px);\n        height: 100%;\n        background: rgba(0, 0, 0, 0.5);\n        z-index: 1025;\n        display: block;\n        pointer-events: auto;\n    }\n    \n    /* Ensure sidebar content is clickable */\n    body.sidebar-open .main-sidebar * {\n        pointer-events: auto !important;\n        z-index: inherit !important;\n    }\n    \n    /* Force content wrapper to be visible and properly positioned */\n    body.sidebar-collapse .content-wrapper,\n    body.sidebar-collapse .main-footer {\n        margin-left: 0 !important;\n        width: 100% !important;\n        padding-left: 15px !important;\n        padding-right: 15px !important;\n    }\n    \n    /* On mobile, when collapsed, make logo even smaller */\n    body.sidebar-collapse .main-header .logo {\n        width: 50px !important;\n        display: flex !important; /* Keep it visible but small */\n        visibility: visible !important;\n        opacity: 1 !important;\n    }\n    \n    body.sidebar-collapse .main-header .logo .logo-lg {\n        display: none !important;\n    }\n}\n\n/* Sidebar Toggle Button Fix */\n.sidebar-toggle {\n    color: #fff !important;\n    background: transparent !important;\n    border: none !important;\n    padding: 15px !important;\n    cursor: pointer !important;\n}\n\n.sidebar-toggle:hover {\n    background: rgba(255, 255, 255, 0.1) !important;\n}\n\n/* Sidebar Menu Styling */\n.sidebar-menu {\n    list-style: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n.sidebar-menu > li > a {\n    position: relative !important;\n    display: block !important;\n    padding: 12px 15px !important;\n    color: #b8c7ce !important;\n    text-decoration: none !important;\n}\n\n.sidebar-menu > li > a:hover,\n.sidebar-menu > li.active > a {\n    background: #1e282c !important;\n    color: #fff !important;\n}\n\n/* Sidebar Dropdown Menu */\n.sidebar-menu .treeview-menu {\n    display: none !important;\n    list-style: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    background: #2c3b41 !important;\n}\n\n.sidebar-menu .treeview.active .treeview-menu {\n    display: block !important;\n}\n\n.sidebar-menu .treeview-menu > li > a {\n    padding: 8px 15px 8px 30px !important;\n    font-size: 16px !important;\n    color: #8aa4af !important;\n}\n\n.sidebar-menu .treeview-menu > li > a:hover {\n    color: #fff !important;\n}\n\n/* Fix Bootstrap 5 conflicts */\n.container,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl,\n.container-xxl {\n    --bs-gutter-x: 1.5rem !important;\n    --bs-gutter-y: 0 !important;\n}\n\n/* Ensure Bootstrap 5 utilities work properly */\n.d-none { display: none !important; }\n.d-block { display: block !important; }\n.d-flex { display: flex !important; }\n.justify-content-center { justify-content: center !important; }\n.align-items-center { align-items: center !important; }\n.text-center { text-align: center !important; }\n.w-100 { width: 100% !important; }\n.h-100 { height: 100% !important; }\n\n/* Bootstrap 5 spacing utilities */\n.m-0 { margin: 0 !important; }\n.p-0 { padding: 0 !important; }\n.mt-3 { margin-top: 1rem !important; }\n.mb-3 { margin-bottom: 1rem !important; }\n.py-3 { padding-top: 1rem !important; padding-bottom: 1rem !important; }\n.px-3 { padding-left: 1rem !important; padding-right: 1rem !important; }\n.py-5 { padding-top: 3rem !important; padding-bottom: 3rem !important; }\n\n/* Fix potential z-index issues */\n.navbar { z-index: 1030 !important; }\n.dropdown-menu { z-index: 1000 !important; }\n.modal { z-index: 1055 !important; }\n.modal-backdrop { z-index: 1050 !important; }\n\n/* Fix font awesome conflicts */\n.fa, .fas, .far, .fal, .fab {\n    font-family: \"Font Awesome 6 Free\", \"Font Awesome 6 Brands\", \"FontAwesome\" !important;\n}\n\n/* Public Page Container - Override AdminLTE for public pages */\n.public-page-container {\n    background: #f0f2f5 !important;\n    min-height: 100vh !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    position: relative !important;\n    z-index: auto !important;\n}\n\n/* Ensure public pages don't inherit admin panel styles */\nbody:not(.hold-transition) .public-page-container,\nbody:not(.skin-blue) .public-page-container,\nbody:not(.sidebar-mini) .public-page-container {\n    margin-left: 0 !important;\n    padding-left: 0 !important;\n}\n\n/* Global Font Size Improvements - Make text larger and more readable */\nbody, html {\n    font-size: 16px !important;\n    line-height: 1.6 !important;\n}\n\n/* Fix font sizes for lists across the entire project */\nul, ol, li {\n    font-size: 16px !important;\n    line-height: 1.6 !important;\n}\n\n/* Specific fixes for different contexts */\n.content-wrapper ul,\n.content-wrapper ol,\n.content-wrapper li,\n.main-content ul,\n.main-content ol,\n.main-content li {\n    font-size: 16px !important;\n    line-height: 1.6 !important;\n}\n\n/* Sidebar menu items should be readable */\n.sidebar-menu ul,\n.sidebar-menu ol,\n.sidebar-menu li,\n.main-sidebar ul,\n.main-sidebar ol,\n.main-sidebar li {\n    font-size: 16px !important;\n    line-height: 1.5 !important;\n}\n\n/* Navigation and dropdown menus */\n.navbar-nav ul,\n.navbar-nav ol,\n.navbar-nav li,\n.dropdown-menu ul,\n.dropdown-menu ol,\n.dropdown-menu li {\n    font-size: 16px !important;\n    line-height: 1.5 !important;\n}\n\n/* Public pages should have normal font sizes */\n.public-page-container ul,\n.public-page-container ol,\n.public-page-container li {\n    font-size: 18px !important;\n    line-height: 1.6 !important;\n}\n\n/* General text elements */\np, div, span, a, button, input, textarea, select {\n    font-size: 16px !important;\n}\n\n/* Table text */\ntable, td, th {\n    font-size: 16px !important;\n}\n\n/* Form elements */\n.form-control, .form-select, .btn {\n    font-size: 16px !important;\n}\n\n/* Card and content areas */\n.card, .card-body, .box, .box-body {\n    font-size: 16px !important;\n}\n\n/* Override small text classes */\n.small, small {\n    font-size: 14px !important;\n}\n\n/* ---------- Map fullscreen mode ---------- */\n/* Header and sidebar are position:fixed, so they must be targeted directly rather than\n   via opacity/transform on a wrapper div, which fixed descendants ignore. */\n.admin-chrome-hidden .main-header {\n    transform: translateY(-100%) !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n    pointer-events: none !important;\n    transition: transform 0.3s ease, opacity 0.3s ease, visibility 0s linear 0.3s !important;\n}\n\n.admin-chrome-hidden .main-sidebar {\n    transform: translateX(-100%) !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n    pointer-events: none !important;\n    transition: transform 0.3s ease, opacity 0.3s ease, visibility 0s linear 0.3s !important;\n}\n\n.content-wrapper.content-wrapper-fullscreen {\n    margin-left: 0 !important;\n    margin-top: 0 !important;\n    width: 100% !important;\n    min-height: 100vh !important;\n    padding: 0 !important;\n    transition: margin-left 0.35s ease-in-out, margin-top 0.35s ease-in-out, width 0.35s ease-in-out !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
